export default __webpack_public_path__ + "static/media/refer-friend-icon.5f31e47a.svg";